import { render, staticRenderFns } from "./HomeStats.vue?vue&type=template&id=2dad0ea2&"
import script from "./HomeStats.vue?vue&type=script&lang=js&"
export * from "./HomeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports